import { useState } from "react";
import { ITopInTransitLanes } from "../../../api/TopInTransitLanes/TopInTransitLanes.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import Toggler from "../../common/Toggler/Toggler";
import "./styles.scss";

interface Props {
  data?: ITopInTransitLanes[];
}

interface ItransitData {
  ports: string;
  [key: string]: number | string;
}

function TopInTransitLanes({ data }: Props) {
  const [checked, setChecked] = useState(true);

  function getData() {
    if (data) {
      const transitData: ItransitData[] = data
        .reduce((res: ItransitData[], item: ITopInTransitLanes) => {
          const { portofLoading, portofDischarge, transitStatus, inTransitCount } = item;
          const ports = `${portofLoading} to ${portofDischarge}`
          const count = parseInt(inTransitCount);
          const existingItem = res.find(item => item.ports === ports);

          if (existingItem) {
            existingItem[transitStatus] = count;
          } else {
            const newItem: ItransitData = {
              ports,
              [transitStatus]: count
            };
            res.push(newItem);
          }
          return res
        }, [])
        .sort((a: ItransitData, b: ItransitData) => {
          const countA = Object.keys(a)
            .filter(key => key !== "ports")
            .reduce((sum, key) => sum + (a[key] as number), 0);
          const countB = Object.keys(b)
            .filter(key => key !== "ports")
            .reduce((sum, key) => sum + (b[key] as number), 0);
          return countB - countA;
        });
      return transitData;
    }
  }

  return (
    <div className="top-transit-in-lanes">
      <WidgetNivoBase.Bar
        title={
          <Tooltips
            label={
              <>
                <span>Dates are in Issue Date</span>
                <span><b>Booked</b> - Has not departed and not arrived</span>
                <span><b>In Transit</b> - Departed but not arrived</span>
                <span><b>Arrived</b> - Has arrival date POD</span>
                <span>Lane: Port of Loading - Port of Discharge</span>
              </>
            }
            children="Top Transit In Lanes"
          />
        }
        data={getData()}
        keys={["Arrived", "In Transit", "Booked"]}
        indexBy="ports"
        marginBottom={50}
        axisLeftName="# Transit"
        axisBottomName=""
        axisBottomRotation={-45}
        groupMode={checked ? "stacked" : "grouped"}
        colors={{ scheme: "category10" }}
        formatValue={(v) => NumberUtils.toShortened(v, 2)}
        formatXAxis={(v) => {
          let split = v.split(" to ");
          return `${split[0].slice(0, 2)}-${split[1].slice(0, 2)}`;
        }}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            itemWidth: 70,
            itemHeight: 12,
            itemDirection: "left-to-right",
            itemsSpacing: 8,
            symbolShape: "circle",
            symbolSize: 12,
            toggleSerie: true,
            translateX: 0,
            translateY: 50,
          },
        ]}
        tooltip={({ indexValue, id, value, color, data }) => (
          <div
            className="tooltip-panel"
            style={{
              color,
            }}
          >
            <div>{indexValue}</div>
            {checked &&
              <div>Total: <strong>{Object.keys(data).filter(key => key !== "ports").reduce((sum, key) => sum + data[key], 0)}</strong></div>
            }
            <div>{id}: <strong>{NumberUtils.numberWithCommas(value)}</strong></div>
          </div>
        )}
        toggler={<Toggler label="Total" checked={checked} toggleChart={(v) => setChecked(v)} />}
      />
    </div>
  );
}

export default TopInTransitLanes;
